import { authSlice } from './reducers'

export const {
    logout,
    uid,
    email,
    accessToken,
    setAuth
} = authSlice.actions;
export default authSlice.actions